<template>
  <div class="wrapper">
    <div v-if="error" class="error-msg">{{ error }}</div>
  </div>
</template>

<script>
import { authService } from "@/services/authService";

export default {
  name: "ControlCenter",
  data() {
    return {
      error: null,
    };
  },
  async created() {
    let parsed;
    try {
      const hashStr = decodeURIComponent(
        window.location.hash.replace(/^#/, "")
      ).split("?")[0];
      parsed = JSON.parse(hashStr);
    } catch {
      this.error = "Invalid parameters";
      return;
    }

    if (!parsed?.ccToken || !parsed?.currentProject) {
      this.error = "Missing required parameters";
      return;
    }

    const { ccToken, currentProject } = parsed;

    // Mark as iframe context so token expiry shows auth guard instead of
    // redirecting to Zitadel login (without affecting Bobbie-specific UI)
    this.$store.commit("setIsInIFrameContext", true);

    let expiresIn;
    try {
      const payload = JSON.parse(
        atob(ccToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
      expiresIn = payload.exp - Math.floor(Date.now() / 1000);
    } catch {
      expiresIn = 3600;
    }

    try {
      // The ccToken is a valid Zitadel JWT — use it directly without backend
      // validation (unlike Bobbie which exchanges an external token)
      await authService.manualUserLogIn({
        accessToken: ccToken,
        idToken: ccToken,
        refreshToken: null,
        scope: "openid profile email",
        tokenType: "Bearer",
        expiresIn,
      });
      this.$router.push(`/${currentProject}`);
    } catch (err) {
      console.error("ControlCenter: failed to authenticate", err);
      this.error = "Authentication failed";
    }
  },
};
</script>

<style scoped>
.wrapper {
  background: black;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.error-msg {
  color: red;
  font-size: 1rem;
}
</style>
